import React from "react";
import { files } from "./configs";
import "./NoToken.css";

function NoToken() {
  return (
    <div id="app__wrap">
      <div className="container" id="noToken__container">
        <div className="title" id="noToken__title">
          <div className="icon">
            <img src={files + "/warning.svg"} alt="잘못된 접근입니다." />
          </div>
          <h3>조사를 진행할 수 없습니다.</h3>
        </div>
        <div className="content" id="noToken__content">
          <p>
            목표인원이 도달해서 조사가 완료되었거나
            <br />
            조사기간이 만료되어 조사가 종료되었을 수 있습니다.
            <br />
            <br />
            자세한 사항은 02-780-0116으로 문의주시면
            <br />
            안내 드리겠습니다.
          </p>
        </div>
      </div>
    </div>
  );
}

export default NoToken;
